/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { GetProcessResponse } from '../models/get-process-response';
import { CreateProcessRequest } from '../models/create-process-request';
import { StartCertProcessRequest } from '../models/start-cert-process-request';
import { ActionApprovalProcessRequest } from '../models/action-approval-process-request';
import { UpdateProcessRequest } from '../models/update-process-request';
import { UpdateProcessFrequencyRequest } from '../models/update-process-frequency-request';
import { UpdateProcessEndDateRequest } from '../models/update-process-end-date-request';
@Injectable({
  providedIn: 'root',
})
class ProcessService extends __BaseService {
  static readonly ProcessGetAllPath = '/Process/GetAll';
  static readonly ProcessGetByIdPath = '/Process/GetById';
  static readonly ProcessCreateRangePath = '/Process/CreateRange';
  static readonly ProcessCreatePath = '/Process/Create';
  static readonly ProcessStartCertProcessPath = '/Process/StartCertProcess';
  static readonly ProcessFormIsValidPath = '/Process/FormIsValid';
  static readonly ProcessApprovePath = '/Process/Approve';
  static readonly ProcessDeclinePath = '/Process/Decline';
  static readonly ProcessUpdatePath = '/Process/Update';
  static readonly ProcessUpdateFrequencyPath = '/Process/UpdateFrequency';
  static readonly ProcessUpdateEndDatePath = '/Process/UpdateEndDate';
  static readonly ProcessDeletePath = '/Process/Delete';
  static readonly ProcessDeleteRangePath = '/Process/DeleteRange';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }
  ProcessGetAllResponse(): __Observable<__StrictHttpResponse<Array<GetProcessResponse>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/Process/GetAll`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<GetProcessResponse>>;
      })
    );
  }  ProcessGetAll(): __Observable<Array<GetProcessResponse>> {
    return this.ProcessGetAllResponse().pipe(
      __map(_r => _r.body as Array<GetProcessResponse>)
    );
  }

  /**
   * @param Id undefined
   */
  ProcessGetByIdResponse(Id?: string): __Observable<__StrictHttpResponse<GetProcessResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (Id != null) __params = __params.set('Id', Id.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/Process/GetById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GetProcessResponse>;
      })
    );
  }
  /**
   * @param Id undefined
   */
  ProcessGetById(Id?: string): __Observable<GetProcessResponse> {
    return this.ProcessGetByIdResponse(Id).pipe(
      __map(_r => _r.body as GetProcessResponse)
    );
  }

  /**
   * @param params The `ProcessService.ProcessCreateRangeParams` containing the following parameters:
   *
   * - `processes`:
   *
   * - `managementAndControlPlanId`:
   */
  ProcessCreateRangeResponse(params: ProcessService.ProcessCreateRangeParams): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.processes;
    if (params.managementAndControlPlanId != null) __params = __params.set('managementAndControlPlanId', params.managementAndControlPlanId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/Process/CreateRange`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param params The `ProcessService.ProcessCreateRangeParams` containing the following parameters:
   *
   * - `processes`:
   *
   * - `managementAndControlPlanId`:
   */
  ProcessCreateRange(params: ProcessService.ProcessCreateRangeParams): __Observable<string> {
    return this.ProcessCreateRangeResponse(params).pipe(
      __map(_r => _r.body as string)
    );
  }

  /**
   * @param request undefined
   */
  ProcessCreateResponse(request: CreateProcessRequest): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/Process/Create`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param request undefined
   */
  ProcessCreate(request: CreateProcessRequest): __Observable<string> {
    return this.ProcessCreateResponse(request).pipe(
      __map(_r => _r.body as string)
    );
  }

  /**
   * @param request undefined
   */
  ProcessStartCertProcessResponse(request: StartCertProcessRequest): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/Process/StartCertProcess`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param request undefined
   */
  ProcessStartCertProcess(request: StartCertProcessRequest): __Observable<Blob> {
    return this.ProcessStartCertProcessResponse(request).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param id undefined
   */
  ProcessFormIsValidResponse(id?: string): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (id != null) __params = __params.set('id', id.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/Process/FormIsValid`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param id undefined
   */
  ProcessFormIsValid(id?: string): __Observable<Blob> {
    return this.ProcessFormIsValidResponse(id).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param request undefined
   */
  ProcessApproveResponse(request: ActionApprovalProcessRequest): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/Process/Approve`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param request undefined
   */
  ProcessApprove(request: ActionApprovalProcessRequest): __Observable<Blob> {
    return this.ProcessApproveResponse(request).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param request undefined
   */
  ProcessDeclineResponse(request: ActionApprovalProcessRequest): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/Process/Decline`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param request undefined
   */
  ProcessDecline(request: ActionApprovalProcessRequest): __Observable<Blob> {
    return this.ProcessDeclineResponse(request).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param request undefined
   */
  ProcessUpdateResponse(request: UpdateProcessRequest): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/Process/Update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param request undefined
   */
  ProcessUpdate(request: UpdateProcessRequest): __Observable<Blob> {
    return this.ProcessUpdateResponse(request).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param request undefined
   */
  ProcessUpdateFrequencyResponse(request: UpdateProcessFrequencyRequest): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/Process/UpdateFrequency`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param request undefined
   */
  ProcessUpdateFrequency(request: UpdateProcessFrequencyRequest): __Observable<Blob> {
    return this.ProcessUpdateFrequencyResponse(request).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param request undefined
   */
  ProcessUpdateEndDateResponse(request: UpdateProcessEndDateRequest): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/Process/UpdateEndDate`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param request undefined
   */
  ProcessUpdateEndDate(request: UpdateProcessEndDateRequest): __Observable<Blob> {
    return this.ProcessUpdateEndDateResponse(request).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param id undefined
   */
  ProcessDeleteResponse(id?: string): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (id != null) __params = __params.set('id', id.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/Process/Delete`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param id undefined
   */
  ProcessDelete(id?: string): __Observable<Blob> {
    return this.ProcessDeleteResponse(id).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param ids undefined
   */
  ProcessDeleteRangeResponse(ids: Array<string>): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = ids;
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/Process/DeleteRange`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param ids undefined
   */
  ProcessDeleteRange(ids: Array<string>): __Observable<Blob> {
    return this.ProcessDeleteRangeResponse(ids).pipe(
      __map(_r => _r.body as Blob)
    );
  }
}

module ProcessService {

  /**
   * Parameters for ProcessCreateRange
   */
  export interface ProcessCreateRangeParams {
    processes: Array<CreateProcessRequest>;
    managementAndControlPlanId?: string;
  }
}

export { ProcessService }
